import React, { ComponentPropsWithoutRef, forwardRef } from 'react';
import { Card, styled, mergeClassNames } from '@beeline.com/bp-design-system';

interface Props {
  dataTest?: string;
  children: React.ReactNode;
  pageTitle?: React.ReactNode;
  noBackground?: boolean;
  overflow?: 'hidden' | 'auto' | 'visible';
}

export const DefaultPageView = forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<Props & ComponentPropsWithoutRef<'div'>>
>(({ pageTitle, children, noBackground, dataTest, className, overflow = 'hidden', ...props }, ref) => (
  <StyledContainer
    data-test={dataTest}
    className={mergeClassNames(`default-page-view ${className || ''}`, {
      noBackground: !!noBackground,
      hasPageTitle: !!pageTitle
    })}
    {...props}
    ref={ref}
  >
    {pageTitle}
    <Card
      dataTest="default-page-view-content"
      className="default-page-view-content"
      style={{ overflowX: overflow, overflowY: overflow }}
      fullSize
      elevation={0}
    >
      {children}
    </Card>
  </StyledContainer>
));

export default DefaultPageView;

const StyledContainer = styled('div')`
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  flex-direction: column;
  padding: ${({ theme }) => `${theme.spacingSize.l} ${theme.spacingSize.l} ${theme.spacingSize.l} ${theme.spacingSize.m}`};

  .default-page-view-content {
    border: 1px solid ${({ theme }) => theme.tokens.colorSurfaceVariant};
    padding: ${({ theme }) => theme.spacingSize.l};
    width: 100%;
    height: 100%;
    min-height: 600px;

    &:has([data-test="pagination-wrapper"]) {
      padding-bottom: 0;
    }
  }

  &.noBackground {
    padding: ${({ theme }) => `${theme.spacingSize.l} 0 0 0`};

    [data-test="page-header"] {
      margin-left: ${({ theme }) => theme.spacingSize.l};
    }

    .default-page-view-content {
      background-color: transparent;
      padding: 0;
      border: none;
    }
  }
  &.hasPageTitle .default-page-view-content {
    margin-top: ${({ theme }) => theme.spacingSize.l};
  }
`;
